import initialState from '../../store/initialState';
import ModalEncuestaTipos from './RechazoTipos';

const RechazoReducer = (state = initialState.rechazo, action) => {
    switch (action.type) {
        case ModalEncuestaTipos.data.MOSTRAR_RECHAZO:
            return ({
                ...state,
                showRechazo: action.payload.showRechazo
            });
        case ModalEncuestaTipos.data.REQUEST_RECHAZO:
            return ({
                ...state,
                enEjecucionAPI: action.payload.enEjecucionAPI
            });
        case ModalEncuestaTipos.data.MOTIVO_DE_RECHAZO:
            return ({
                ...state,
                motivo: action.payload.motivo
            });
        case ModalEncuestaTipos.data.LOAD_POSTS_REQUEST_RECHAZO:
            return ({
                ...state,
                enEjecucionAPI:false,
                responseApi: action.payload.responseApi
            });
        case ModalEncuestaTipos.data.ERROR_API_RECHAZO:
            return ({
                ...state,
                enEjecucionAPI:false,
                errorApi: action.payload.errorApi
        });
        case ModalEncuestaTipos.data.MOTIVOS_DISPONIBLES:
            return ({
                ...state,
                enEjecucionAPI:false,
                motivosDisponible: action.payload.motivosDisponible
        });
        default:
            return state;
    }
}

export default RechazoReducer;